import { createContext, useContext, useEffect, useState } from "react";

const FlagsContext = createContext({ flags: {}, loaded: false, refresh: () => {} });

export function FlagsProvider({ children }) {
  const [flags, setFlags] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refresh = () => {
    fetch("/api/flags")
      .then(r => r.ok ? r.json() : {})
      .then(m => setFlags(m && typeof m === "object" ? m : {}))
      .catch(() => setFlags({}))
      .finally(() => setLoaded(true));
  };

  useEffect(refresh, []);

  return (
    <FlagsContext.Provider value={{ flags, loaded, refresh }}>
      {children}
    </FlagsContext.Provider>
  );
}

// Read a single flag. Returns false until flags have loaded, so callers can
// safely render the off-state during the brief fetch window.
export function useFlag(key) {
  const { flags } = useContext(FlagsContext);
  return !!flags[key];
}

// Read the full flags object (and loaded indicator) when a component needs
// to react to multiple flags at once.
export function useFlags() {
  return useContext(FlagsContext);
}
